<template>
    <div v-show="showResults" class="separation-mobile">
        <br class="d-md-none">
        <div class="row">
            <div class="col-8">
                <strong><label for="totalSpent">{{ text.totalSpent }}</label></strong>
            </div>
            <div class="col-4 text-right">
                <p><strong>{{ refundResults.totalSpentAmount + ' €' }}</strong></p>
            </div>
        </div>
        <div class="row">
        </div>
        <div v-if="!isComplexData">
            <simple-results></simple-results>
        </div>
        <div v-if="isComplexData">
            <complex-results :colNumber="this.refundResults.simulationType"></complex-results>
        </div>
        <div class="form-group row">
            <div class="col-md-12">
                <div v-for="(item,index) in refundResults.informationMessages" :key="index">
                    <div v-show="item" class="alert alert-info text-center">
                        {{ item }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import resources from '../helpers/resources'

export default {
    data() { return { text : resources } },
    props: {
        isComplexData: {
            type:Boolean,
            default:false
        }
    },
    computed: {
        refundResults () { return this.$store.state.refundResults },
        showResults () { return this.$store.getters.showResults },
        errorMessages () { return this.$store.state.errors }
    },
    methods: {
        showMessages () {
            this.errorMessages.forEach(element => {
                this.$bvToast.toast(element, {
                title: this.text.standardErrorTitle,
                variant: 'danger',
                solid: true,
                appendToast: true
                })
            })
        }
    },
    watch: {
        errorMessages: function(value, oldValue) {
            this.showMessages()
            // Clears the error stack (only if it is not empty)
            if (value.length != 0 && oldValue.length >= 0) {
                this.$store.dispatch('clearErrors')
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Results.vue